import { EnumUserLocale } from 'modules/common/types/locale'
import { FALLBACK_LOCALE } from '_constants'

export const getLocales = () =>
  (process.env.NEXT_PUBLIC_AVAILABLE_LOCALES || FALLBACK_LOCALE).split(
    ','
  ) as EnumUserLocale[]
